export default __webpack_public_path__ + "static/media/loading-cog.e895823f.gif";